import { render } from "./EvaluationQuestionsLandingPage.vue?vue&type=template&id=0e26dcaf&ts=true"
import script from "./EvaluationQuestionsLandingPage.vue?vue&type=script&lang=ts"
export * from "./EvaluationQuestionsLandingPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__